import { render, staticRenderFns } from "./UserTags.vue?vue&type=template&id=0622594d&"
import script from "./UserTags.vue?vue&type=script&lang=js&"
export * from "./UserTags.vue?vue&type=script&lang=js&"
import style0 from "./UserTags.vue?vue&type=style&index=0&id=0622594d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports